import React from 'react';
import { FlexView, Text } from '@goodfynd/ui';
import classnames from 'clsx';
import Link from 'next/link';

import classes from './GoodfyndSitesStatusPage.module.css';

type StatusAction = {
  href: string;
  label: string;
  external?: boolean;
};

export type GoodfyndSitesStatusPageProps = {
  action?: StatusAction;
  children?: React.ReactNode;
  className?: string;
  description: string;
  title: string;
};

export function GoodfyndSitesStatusPage({
  action,
  children,
  className,
  description,
  title,
}: GoodfyndSitesStatusPageProps) {
  return (
    <FlexView
      align="center"
      className={classnames(classes.wrapper, className)}
      direction="column"
      gap={16}
      justify="center"
      role="alert"
    >
      <Text align="center" as="heading2" className={classes.title}>
        {title}
      </Text>

      <Text align="center" className={classes.description}>
        {description}
      </Text>

      {action ? (
        <div className={classes.actions}>
          <Link
            className={classes.cta}
            href={action.href}
            rel={action.external ? 'noreferrer' : undefined}
            target={action.external ? '_blank' : undefined}
          >
            {action.label}
          </Link>
        </div>
      ) : null}

      {children}
    </FlexView>
  );
}
